const Types = {
  CREATE_LOGIN_PROFILE_REQUEST: '@loginProfiles/CREATE_LOGIN_PROFILE_REQUEST',
  CREATE_LOGIN_PROFILE_SUCCESS: '@loginProfiles/CREATE_LOGIN_PROFILE_SUCCESS',
  DELETE_LOGIN_PROFILE_REQUEST: '@loginProfiles/DELETE_LOGIN_PROFILE_REQUEST',
  DELETE_LOGIN_PROFILE_SUCCESS: '@loginProfiles/DELETE_LOGIN_PROFILE_SUCCESS',
  FAILURE: '@loginProfiles/FAILURE',
};

export default Types;
